export enum LANG {
    KM = 'km',
    EN = "en"
}